export const getZodiacSign = (day, month) => {
  const signs = [
    { name: 'Aries', symbol: '♈', start: [3, 21], end: [4, 19] },
    { name: 'Taurus', symbol: '♉', start: [4, 20], end: [5, 20] },
    { name: 'Gemini', symbol: '♊', start: [5, 21], end: [6, 20] },
    { name: 'Cancer', symbol: '♋', start: [6, 21], end: [7, 22] },
    { name: 'Leo', symbol: '♌', start: [7, 23], end: [8, 22] },
    { name: 'Virgo', symbol: '♍', start: [8, 23], end: [9, 22] },
    { name: 'Libra', symbol: '♎', start: [9, 23], end: [10, 23] },
    { name: 'Scorpio', symbol: '♏', start: [10, 24], end: [11, 21] },
    { name: 'Sagittarius', symbol: '♐', start: [11, 22], end: [12, 21] },
    { name: 'Capricorn', symbol: '♑', start: [12, 22], end: [1, 20] },
    { name: 'Aquarius', symbol: '♒', start: [1, 21], end: [2, 18] },
    { name: 'Pisces', symbol: '♓', start: [2, 19], end: [3, 20] },
  ]

  for (const sign of signs) {
    const [startMonth, startDay] = sign.start
    const [endMonth, endDay] = sign.end

    if (startMonth === endMonth) {
      // Same month range
      if (month === startMonth && day >= startDay && day <= endDay) {
        return sign
      }
    } else {
      // Cross-month range (Dec-Jan, Jan-Feb, Feb-Mar)
      if (month === startMonth && day >= startDay) {
        return sign
      }
      if (month === endMonth && day <= endDay) {
        return sign
      }
    }
  }

  return { name: 'Unknown', symbol: '?' }
}

